import PersistStorage from "modules/utils/PersistStorage";
import {LOCALE} from "modules/constants";

export abstract class AnswersUtils {
	private static key = `__ANSWERS__${LOCALE}`;

	public static get(): Record<string, number> {
		try {
			const answers = PersistStorage.GET(AnswersUtils.key) || "{}";
			return JSON.parse(answers) as Record<string, number>;
		} catch (e) {
			return {};
		}
	}

	public static save(answers: Record<string, number>) {
		PersistStorage.SET(AnswersUtils.key, answers);
	}

	public static clear() {
		PersistStorage.REMOVE(AnswersUtils.key);
	}
}
